import IntegratedChatScreen from '../components/chat/IntegratedChatScreen';
import './Chat.css';

function Chat() {
  return (
    <div className="chat-page">
      <IntegratedChatScreen />
    </div>
  );
}

export default Chat;
